// portfolio.js — local-first evidence portfolio (learner work + adult notes + rubric level + standards).
const KEY = "mwq_portfolio_v1";
export const RUBRIC = ["Beginning", "Developing", "Secure", "Extending"];
export const EVIDENCE_TYPES = ["writing", "spoken_explanation", "audio", "photo_or_drawing", "experiment_record", "project", "composition", "code", "artwork", "movement_checklist", "reflection", "adult_observation", "quiz"];

function read() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } }
function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); window.dispatchEvent(new Event("mwq-portfolio-changed")); } catch { /* ignore */ } }

export function listEntries() { return read().sort((a, b) => (b.date || "").localeCompare(a.date || "")); }
export function addEntry({ subject = "", unitId = "", unitTitle = "", type = "reflection", title = "", note = "", rubric = "", standards = [], adultNote = "", objective = "" }) {
  const e = { id: `ev_${Date.now().toString(36)}`, date: new Date().toISOString(), subject, unitId, unitTitle, type, title, note: note.slice(0, 2000), rubric, standards, adultNote: adultNote.slice(0, 1000), objective };
  write([e, ...read()]); return e;
}
export function updateEntry(id, patch) { write(read().map((e) => (e.id === id ? { ...e, ...patch } : e))); }
export function removeEntry(id) { write(read().filter((e) => e.id !== id)); }
export function subscribePortfolio(setter) {
  const f = () => setter(listEntries());
  window.addEventListener("mwq-portfolio-changed", f);
  return () => window.removeEventListener("mwq-portfolio-changed", f);
}
